export default "__VITE_ASSET__CgoXodnC__"